module.exports = __webpack_public_path__ + "img/tutorial-grid2.39f11df8.png";